import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import {
  AFFILIATE_TRACKERS_PERMISSIONS,
  AFFILIATE_TRACKERS_ROUTE_NAME,
} from '@modules/affiliate-trackers/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  AFFILIATE_TRACKERS_CREATIVES_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_CREATIVES,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliateTrackersCreativesModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_TRACKERS_ROUTE_NAME, {
      name: AFFILIATE_TRACKERS_CREATIVES_ROUTE_NAME,
      path: 'creatives/:id/:type',
      permission: AFFILIATE_TRACKERS_PERMISSIONS.SHOW_CREATIVE,
      component: () => import('./pages/AffiliateTrackersCreativesListPage/AffiliateTrackersCreativesListPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_CREATIVES, getTranslationKeys);
  }
}
